import React, { useEffect } from 'react';
import { 
  Plug, Home, Car, Apple, Gamepad2, PawPrint, Package, Sparkles,
  ArrowRight, CheckCircle 
} from 'lucide-react';
import { productCategories } from '../utils/mockData';
import { Link } from 'react-router-dom';

const iconMap = {
  Plug, Home, Car, Apple, Gamepad2, PawPrint, Package, Sparkles
};

export const Products = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const toyProducts = [
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/rqy5u7lp_a59e5143bd862eed78596d71aa6f3aae.webp',
      title: 'My Little Box of Emotions',
      description: 'Eğitici duygular kutusu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/ba2qy2kl_10dd08d0a083264a7dc636b3182db34d.jpg',
      title: 'Learning Resources TotBot',
      description: 'Sayı öğrenme robotu'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/g7lbrxqy_oyuncak3.webp',
      title: 'Smart Toys Müzikli Tırtıl',
      description: 'Gelişim oyuncağı'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_packaging-hub-14/artifacts/khrrioax_08f10b8c9c003b447a2a5d39f316c5f1.webp',
      title: 'Trefl Baby İlk Puzzle',
      description: 'Bebek eğitim seti'
    }
  ];

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-br from-lime-600 to-lime-700 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-white mb-6">
              Ürün Kategorilerimiz
            </h1>
            <p className="text-xl text-lime-100">
              Her sektöre özel, kaliteli ve çevre dostu ambalaj çözümleri
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {productCategories.map((category) => {
              const IconComponent = iconMap[category.icon];
              
              return (
                <div 
                  key={category.id}
                  className="group bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
                >
                  <div className="w-16 h-16 bg-lime-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-lime-600 transition-colors">
                    <IconComponent className="w-8 h-8 text-lime-600 group-hover:text-white transition-colors" />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-6 group-hover:text-lime-600 transition-colors">
                    {category.name}
                  </h3>

                  <div className="space-y-2 mb-6">
                    {category.products.slice(0, 3).map((product, idx) => (
                      <div key={idx} className="flex items-center space-x-2 text-sm text-gray-700">
                        <CheckCircle className="w-4 h-4 text-lime-500 flex-shrink-0" />
                        <span>{product}</span>
                      </div>
                    ))}
                    {category.products.length > 3 && (
                      <div className="text-sm text-lime-600 font-medium">
                        +{category.products.length - 3} daha fazla
                      </div>
                    )}
                  </div>

                  <Link
                    to={`/urunler/${category.slug}`}
                    className="w-full flex items-center justify-center space-x-2 px-6 py-3 bg-lime-50 text-lime-600 rounded-lg font-medium group-hover:bg-lime-600 group-hover:text-white transition-all"
                  >
                    <span>Detayları Gör</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Custom Solutions Section */}
      <section className="py-20 bg-gradient-to-br from-lime-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl shadow-xl p-12 border border-lime-100">
              <div className="text-center mb-8">
                <h2 className="text-4xl font-bold text-gray-900 mb-4">
                  Özel Tasarım Hizmeti
                </h2>
                <p className="text-xl text-gray-600">
                  İhtiyaçlarınıza özel ambalaj çözümleri geliştiriyoruz
                </p>
              </div>

              <div className="grid md:grid-cols-3 gap-6 mb-8">
                {[
                  { title: 'Özel Boyut', desc: 'İstediğiniz ölçülerde üretim' },
                  { title: 'Özel Baskı', desc: 'Marka kimliğinize uygun tasarım' },
                  { title: 'Özel Malzeme', desc: 'İhtiyaca göre malzeme seçimi' }
                ].map((item, idx) => (
                  <div key={idx} className="text-center p-6 bg-lime-50 rounded-xl">
                    <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                ))}
              </div>

              <div className="text-center">
                <Link
                  to="/iletisim"
                  className="inline-flex items-center space-x-2 px-8 py-4 bg-lime-600 text-white rounded-lg font-semibold hover:bg-lime-700 transition-all hover:shadow-lg"
                >
                  <span>Teklif İsteyin</span>
                  <ArrowRight className="w-5 h-5" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
